import React from 'react';
import styled from 'styled-components';
import { IoIosArrowBack } from 'react-icons/io';

const ButtonHolder = styled.span`
  ${({ theme }) => `
    display: inline-block;
    padding: 0.5em;
    padding-left: 0;
    color: ${theme.palette.primary.main};

    :hover {
      cursor: pointer;
    }
    
    * {
      vertical-align: middle;
    }
  `}
`;

interface Props {
  children: string;
  onClick: () => void;
}

const BackButton = ({ onClick, children: label }: Props) => (
  <ButtonHolder onClick={onClick}>
    <IoIosArrowBack />
    {label}
  </ButtonHolder>
);

export default BackButton;
